// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"370":"027cdc7d","429":"b71eb3c4","481":"7a5bc30f","486":"781c8e91","739":"027cdc7d","938":"12af00e0","978":"7a5bc30f"}[chunkId] + ".chunk.css";
};